<template>
  <div class="loading d-flex justify-content-center">
    <div class="spinner-border" role="status">
      <span class="sr-only">Aguarde...</span>
    </div>
    <span v-if="textoMensagem">{{ textoMensagem }}</span>
    <span v-else>Aguarde...</span>

  </div>
</template>

<script>
export default {
  name: "Loading",
  props: ["textoMensagem"],

  mounted() {
  },
};
</script>

<style scoped lang="scss">
.loading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: var(--cor-principal);
  color: var(--cor-texto);
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}

.spinner-border {
  filter: brightness(6);
}

span {
  padding: 5vw 10vw;
  text-transform: uppercase;
  color: #fff;
  font-size: 1.1rem;
  letter-spacing: 0.15rem;
  font-weight: bold;
  text-align: center;
}
</style>
